<template>
  <div style="text-align: left; line-height: 27px; font-size: 16px; color: black; background-color: white; padding: 20px; height: calc(100vh - 170px); overflow-y: auto " class="aaa">
    <div style="padding: 10px">
      <p>随着智能设备的快速普及与信息技术的飞速发展，培养具有信息化视野和“数 字+”思维模式的复合型人才成为高校人才培养的重大挑战。2020 年 3 月 29 日至 4 月 1日，习近平总书记在浙江考察时指出，要抓住产业数字化、数字产业化赋 予的机遇， 加快 5G 网络、数据中心等新型基础设施建设，大力推进科技创新，形成发展新动能。</p>
      <p>Python 语言是目前最流行的面向对象程序设计语言， 不仅继承了传统编译语 言的强大功能和通用性,同时也借鉴了简单脚本和解释语言的易用性，拥有易于学 习、易于阅读、易于维护、标准库广泛、可移植性良好、可扩展性良好等诸多有 点。基于此，越来越多的高校为了训练学生的基本编程技能，培养学生抽象分析 问题和设计算法、编程实现解决问题的能力，《Python 程序设计》作为一门基础必修课被广泛的纳入到了计算机专业人才和非计算机专业人才的培养方案中。同时，由于计算机系统构建了一个完全不同于现实世界的复杂虚拟环境，其内部运行过程构建于高度复杂和层次化的软硬件系统之上，具有不可见性，难以被直观 地观察到。从而使得学生难以理解 Python 语言的程序代码内部运行过程和原理， 这给教学带来了极大的挑战。</p>
      <p>程序执行过程不可见问题主要体现在以下几个方面：</p>
      <p>（1）程序执行过程不可见，对理解程序执行逻辑造成困难；</p>
      <p>（2）非计算机专业学生缺乏对计算机系统结构的基础知识，无法融会贯通、 举一反三，教学效果不佳；</p>
      <p>（3）Python 程序设计中函数调用和参数传递涉及计算机内存中重要的数据 结构，但其不可见性使学生难以理解其基本原理；</p>
      <p>（4）面向对象程序设计语言中的引用、动态内存分配、取地址、指针等操作 与计算机系统结构基础知识密切相关，但不可见性使得相关知识点的教学难以开展；</p>
      <p>（5）目前程序设计语言课程仅停留在简单的数字逻辑和基本语法教学层面， 学生难以理解问题背后的真实原因，“知其然不知其所以然”，容易造成为了考试 而学习的现象，难以真正做到将程序设计语言作为一种工具应用到问题求解过程中。</p>
      <p>
        本实验为顺应我校多学科交叉融合的复合型卓越人才培养趋势，以“立德树 人”为根本， 激发学生 Python 语言程序设计的学习热情， 突破编程语言学习时计 算机内部运行状态不可见的瓶颈，坚持“学生中心、问题导向、学科融合、创新 实践、追求卓越”的实验教学理念，按照“虚实结合、以虚补实”的原则，以满 足不同层次 Python 学习对象需求为切入点， 采用虚拟现实、人工智能、嵌入式开发等技术完全自主研发了 Python 语言可视化执行虚拟仿真实验平台。旨在让学生 深刻领会 Python 程序设计开发理念， 通过综合设计类实验的探究体现多维度赋能 虚拟仿真生态系统及凸显计算思维与系统思维的高阶性。
      </p>
    </div>
  </div>
</template>
<script>
  import Sortable from 'sortablejs'
  export default {
    data() {
      return {
        col: [
          {
            label: '顺序号',
            prop: 'seqNum'
          },
          {
            label: '图书名称',
            prop: 'bookName'
          }
        ],
        dropCol: [
          {
            label: '顺序号',
            prop: 'seqNum'
          },
          {
            label: '图书名称',
            prop: 'bookName'
          }
        ],
        tableData: [
          {
            id: '1',
            seqNum: '2016-05-02',
            bookName: '赵'
          },
          {
            id: '2',
            seqNum: '2016-05-02',
            bookName: '钱'
          },
          {
            id: '3',
            seqNum: '2016-05-02',
            bookName: '孙'
          },
          {
            id: '4',
            seqNum: '2016-05-02',
            bookName: '李'
          },
        ]
      }
    },
    mounted() {
      this.rowDrop()
      this.columnDrop()
    },
    methods: {
      //行拖拽
      rowDrop() {
        const tbody = document.querySelector('.aaa .el-table__body-wrapper tbody')
        const _this = this
        Sortable.create(tbody, {
          onEnd({ newIndex, oldIndex }) {
            const currRow = _this.tableData.splice(oldIndex, 1)[0]
            _this.tableData.splice(newIndex, 0, currRow)
          }
        })
      },
      //列拖拽
      columnDrop() {
        const wrapperTr = document.querySelector('.aaa .el-table__header-wrapper tr')
        this.sortable = Sortable.create(wrapperTr, {
          animation: 180,
          delay: 0,
          onEnd: evt => {
            const oldItem = this.dropCol[evt.oldIndex]
            this.dropCol.splice(evt.oldIndex, 1)
            this.dropCol.splice(evt.newIndex, 0, oldItem)
          }
        })
      }
    }
  }
</script>
<style scoped>

  p {
    text-indent: 2em;
  }

</style>



// WEBPACK FOOTER //
// src/components/syzy/syzygl.vue